<template>
  <span v-if="gpsTrack.isBicycleTrack()" va-b-tooltip.hover :title="$t('bicycleTrack')">
    <img :style="{height: height + 'px'}" :src="icons.bicycle"/>
  </span>
  <span v-else-if="gpsTrack.isWalkTrack()" va-b-tooltip.hover :title="$t('walkTrack')">
    <img :style="{height: height + 'px'}" :src="icons.shoe"/>
  </span>
  <span v-else-if="gpsTrack.isMushroomTrack()" va-b-tooltip.hover :title="$t('mushroomTrack')">
    <img :style="{height: height + 'px'}" :src="icons.mushroomIcon" />
  </span>
</template>

<script lang="ts">
import BaseComponent from './Base.vue';
import GpsTrack from '@/ts/GpsTrack';
import { defineComponent, type PropType } from "vue";

export default defineComponent({
    extends: BaseComponent,
    props: {
        gpsTrack: { required: true,
            type: Object as PropType<GpsTrack>
        },
        height: { required: true,
            type: null as PropType<number | string>
        }
    }
})

</script>
